import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import AutoComplete from 'material-ui/AutoComplete';

import { updateVesselOrder } from 'actions/vessels/orders';
import api from 'services';
import { RaisedButton } from 'material-ui';

class Name extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            vesselNames: [],
            vesselName: props.vesselOrder.vesselName,
            imoNumber: props.vesselOrder.imoNumber,
            DWT: props.vesselOrder.DWT,
            BLT: props.vesselOrder.BLT,
            _id: props.vesselOrder.vessel,
        };

        this.dAutocomplete = _.debounce((searchText) => {
            api.findVessel(searchText)
                .then((response) => {
                    const vesselNames = response.data.data.map(vessel => ({
                        name: `${vessel.name} (imoNumber - ${vessel.imoNumber})`,
                        item: vessel,
                    }));

                    this.setState({
                        vesselNames,
                    });
                }).then(() => {
                    const newVesselOrder = _.cloneDeep(this.props.vesselOrder);
                    newVesselOrder.vesselName = searchText;
                    this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);
                })
                .catch(() => null);
        }, 1000);


        this.changeVesselName = this.changeVesselName.bind(this);
        this.chooseVessel = this.chooseVessel.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            vesselName: props.vesselOrder.vesselName,
            imoNumber: props.vesselOrder.imoNumber,
            DWT: props.vesselOrder.DWT,
            BLT: props.vesselOrder.BLT,
            _id: props.vesselOrder.vessel,
        });
    }

    changeVesselName(searchText) {
        this.setState({
            vesselName: searchText,
        }, () => {
            this.dAutocomplete(searchText);
        });
    }

    chooseVessel(updateProperties) {
        if (!updateProperties) {
            return;
        }

        const newVesselOrder = _.cloneDeep(this.props.vesselOrder);

        newVesselOrder.vesselName = updateProperties.name;
        newVesselOrder.vessel = updateProperties.item._id;
        newVesselOrder.imoNumber = updateProperties.item.imoNumber;
        newVesselOrder.DWT = updateProperties.item.dw.summer;
        newVesselOrder.BLT = updateProperties.item.blt;

        this.props.updateVesselOrder(this.props.numberOrderTable, newVesselOrder);

        this.setState({
            imoNumber: updateProperties.item.imoNumber,
            DWT: updateProperties.item.dw.summer,
            BLT: updateProperties.item.blt,
            _id: updateProperties.item._id,
        });
    }
    render() {
        const errorVesselName = this.props.errorVesselName ? this.props.errorVesselName.messages[0] : '';

        const { _id, vesselName } = this.state;
        const { params } = this.props;

        return (
            <div>
                <div className='row'>
                    <div className='column-left'>
                        Vessel name:
                    </div>
                    <div className='column-right' style={{ display: 'flex' }}>
                        <AutoComplete
                            name='vesselName'
                            textFieldStyle={{ fontSize: '13px' }}
                            hintText='Vessel name'
                            errorText={errorVesselName}
                            searchText={this.state.vesselName || ''}
                            dataSource={this.state.vesselNames}
                            dataSourceConfig={{ text: 'name', value: 'item' }}
                            onUpdateInput={this.changeVesselName}
                            onNewRequest={this.chooseVessel}
                            filter={AutoComplete.noFilter}
                            fullWidth
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                            }}
                            style={{ display: 'flex', width: '70%', marginRight: '10px' }}
                        />
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px', margin: 'auto 0' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Composition'
                            onClick={() => { 
                                let url = `emailId=${params.id}`;
                                if (_id && vesselName) {
                                    url += `&_id=${_id}&name=${vesselName}`;
                                }
                                window.open(`${window.location.origin}/vessels/composition?${url}`, '_blank');
                            }}
                            secondary
                        />
                    </div>
                </div>


                <div className='row'>
                    <div className='column-left'>
                        imoNumber:
                    </div>
                    <div className='column-right'>
                        <div className='label'>
                            {this.state.imoNumber}
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='column-left'>
                        DWT:
                    </div>
                    <div className='column-right'>
                        <div className='label'>
                            {this.state.DWT}
                        </div>
                    </div>
                </div>

                <div className='row'>
                    <div className='column-left'>
                        BLT:
                    </div>
                    <div className='column-right'>
                        <div className='label'>
                            {this.state.BLT}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        const errorVesselName = state.vesselOrders.items[ownProps.numberOrderTable].validateErrors.find(validateError => validateError.field === 'vessel');

        return {
            numberOrderTable: ownProps.numberOrderTable,
            errorVesselName,
            vesselOrder: state.vesselOrders.items[ownProps.numberOrderTable],
        };
    },
    dispatch => bindActionCreators({
        updateVesselOrder,
    }, dispatch),
)(withRouter(Name));



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Vessel/Sidebar/Order/Name.jsx